import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';
import { ScrAssociadosPesquisaComponent } from './scr-associados/scr-associados-pesquisa.component';
import { ScrControleComponent } from './scr-controle/scr-controle.component';
import { IpocCadastroComponent } from './scr-ipoc/ipoc-cadastro.component';
import { IpocEnvioComponent } from './scr-ipoc/ipoc-envio.component';
import { IpocPesquisaComponent } from './scr-ipoc/ipoc-pesquisa.component';
import { ScrPesquisaComponent } from './scr-pesquisa/scr-pesquisa.component';
import { SCRImportacaoComponent } from './scr/scr-importacao.component';

const routes: Routes = [

  {
    path: 'integracao/scr',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],

    children:[
        {
          path: '',
          redirectTo:'pesquisa',
          pathMatch:'full'

        },
        {
          path: 'importacao',
          component: SCRImportacaoComponent,
          data: { canReuse: false }
        },
        {
          path: 'pesquisa',
          component: ScrPesquisaComponent,
          data: { canReuse: false }
        },
        {
          path: 'associados',
          component: ScrAssociadosPesquisaComponent,
          data: { canReuse: false },
          resolve: {
            agentes: AgenteFinanceiroResolver,
          },
        },
        // {
        //   path: 'controle',
        //   component: ScrControleComponent,
        //   data: { canReuse: false }
        // },
        {
          path: 'ipoc',
          component: IpocPesquisaComponent,
          data: { canReuse: false }
        },
        {
          path: 'ipoc/envio',
          component: IpocEnvioComponent,
          data: { canReuse: false }
        },
        {
          path: 'ipoc/cadastro',
          component: IpocCadastroComponent,
          data: { canReuse: false}
       }
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntegracaoRoutingModule { }
